import {Either, isLeft, isRight, left, right} from 'fp-ts/Either';
import {Branded, TypeOf, brand} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface BeneficiaryNameBrand {
    readonly BeneficiaryName: unique symbol;
}

const validateBeneficiaryName = (value: string | undefined): Either<string, BeneficiaryName> => {
    let errorText = '';

    if (value) {
        const maxLength = 140
        const regexp = /^[a-zA-Z0-9 .]{1,140}$/;
        if (!regexp.test(value)) {
            errorText = 'Can contain only letters, digits, dots and spaces';
        }
        if (value.length > maxLength) {
            errorText = `Should have ${maxLength} characters or less`;
        }
    } else {
        errorText = 'Required';
    }

    return value && !errorText ? right(value as BeneficiaryName) : left(errorText);
};

export const BeneficiaryName = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, BeneficiaryNameBrand> => isRight(validateBeneficiaryName(n)),
    'BeneficiaryName'
);

export const validateBeneficiaryNameField = (value: string | undefined) => {
    const checkResult = validateBeneficiaryName(value?.trim());
    return isLeft(checkResult) ? checkResult.left : undefined;
};

export type BeneficiaryName = TypeOf<typeof BeneficiaryName>;
